import React from "react";

function Projects() {
    const projects = [
        {
            title: "Crypto Blender",
            description: "A tool to mix cryptocurrencies in order to increase the privacy of transactions.",
            technologies: "Rust, Solidity, Typescript, Node.js, React, Makefile",
            link: "https://github.com/augustovicente/blender",
        },
        {
            title: "Dockerized Microservices Template",
            description: "A project containing a basic structure of microservices using Docker. It already comes with the prometheus and grafana monitoring tools structure and a logging service.",
            technologies: "Node.js, Typescript, Docker, Prometheus, Grafana, Shell",
            link: "https://github.com/augustovicente/microservices-template",
        },
        {
            title: "Oembed Validator",
            description: "A simple tool to validate oembed responses, checking if the response content follows the oembed standard from the documentation.",
            technologies: "Node.js",
            link: "https://github.com/augustovicente/oembed-validator",
        },
        {
            title: "Issuu API SDK (collaboration)",
            description: "A SDK for the Issuu API V2 that is used by customers and also the integrations team.",
            technologies: "Node.js, Typescript",
            link: "https://github.com/issuu/issuu-api-sdk",
        },
        {
            title: "Playground Issuu API SDK",
            description: "A playground for the Issuu API V2 SDK so customers can test and see how the SDK works.",
            technologies: "React, Typescript",
            link: "https://github.com/augustovicente/issuu-sdk-playground",
        },
        {
            title: "Web3 use Polygon Network",
            description: "A script to make easier to use the Polygon Network in the Web3 in common websites.",
            technologies: "JS, Web3, Ethereum",
            link: "https://github.com/augustovicente/web3-use-polygon",
        },
        {
            title: "Workshop - Deploy Application to Production",
            description: "A workshop to teach how to deploy an application to production, presented in IFPR Jacarezinho.",
            technologies: "Node.js, Typescript, Shell",
            link: "https://github.com/augustovicente/WorkshopIFPR",
        },
        {
            title: "Script - AdonisJS send file as response from buffer, not saving in disk",
            description: "A script to generate a pdf and send the file as response directly from buffer in AdonisJS, without saving the content in disk, avoiding the need to manage the files in the server.",
            technologies: "Node.js, AdonisJS, Typescript",
            link: "https://gist.github.com/augustovicente/6ae979818f06f9739c378f7c05ee2673",
        },
        {
            title: "Issuu Wordpress Plugin (collaboration)",
            description: "The new version of the Issuu Wordpress Plugin using the new API V2.",
            technologies: "PHP, Wordpress",
            link: "https://github.com/issuu/issuu-panel",
        },
        {
            title: "NFTCommit",
            description: "My thesis project, a platform to create NFTs from commits in Git servers.",
            technologies: "Node.js, Typescript, Solidity, Ethereum",
            link: "https://github.com/augustovicente/nft-commit",
        },
    ];

    return (
        <section id="projects">
            <h2>Projects</h2>
            <div className="projects-grid">
            {projects.map((project, index) => (
                <article className="project-card" key={index}>
                    <h3>{project.title}</h3>
                    <p>{project.description}</p>
                    <p className="project-tech"><strong>Technologies:</strong> {project.technologies}</p>
                    <a className="project-link" href={project.link} target="_blank" rel="noreferrer">
                        View project
                    </a>
                </article>
            ))}
            </div>
        </section>
    );
}

export default Projects;
